import './SmartQuiz.css';

interface Step {
  label: string;
}

interface StepperProps {
  steps: Step[];
  currentStep: number;
}

const Stepper: React.FC<StepperProps> = ({ steps, currentStep }) => (
  <div className="sq-stepper">
    {steps.map((s, i) => {
      const stepNum = i + 1;
      const isCompleted = stepNum < currentStep;
      const isActive = stepNum === currentStep;
      return (
        <div key={s.label} className="sq-stepper__item">
          <span
            className={`sq-stepper__circle ${isCompleted ? 'sq-stepper__circle--done' : ''} ${isActive ? 'sq-stepper__circle--active' : ''}`}
          >
            {isCompleted ? '✓' : stepNum}
          </span>
          <span className={`sq-stepper__label ${isActive ? 'sq-stepper__label--active' : ''}`}>
            {s.label}
          </span>
          {i < steps.length - 1 && <span className="sq-stepper__line" />}
        </div>
      );
    })}
  </div>
);

export default Stepper;
